import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'

import counter from '@/duck/counter'
import panel from '@/duck/panel'
import timeline from '@/duck/timeline'
import dashboard from '@/duck/dashboard'
import user from '@/duck/user'

const createRootReducer = (history) => combineReducers({
    router: connectRouter(history),
    counter,
    panel,
    timeline,
    dashboard,
    user
})
export default createRootReducer